import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import ImageUpload from './ImageUpload';
import { uploadAndAnalyze } from '../api/imageQuality';

/**
 * Dialog wrapper for uploading a photo directly from the Items Catalog.
 *
 * Props:
 *   open            {boolean}   Controls dialog visibility
 *   onClose         {Function}  Called when the user dismisses the dialog
 *   item            {Object}    Item row from ItemsList — must have item_code and brand
 *   onUploadSuccess {Function}  Called with a success message after a successful upload
 */
export default function ItemUploadModal({ open, onClose, item, onUploadSuccess }) {
  if (!item) return null;

  const handleUpload = async (file, metadata, onProgress) => {
    const result = await uploadAndAnalyze(file, metadata, onProgress);
    if (result && result.success) {
      onUploadSuccess(`Photo uploaded for ${item.item_code}. Quality analysis will run tonight.`);
      onClose();
    } else {
      throw new Error((result && result.error) || 'Upload failed');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" component="span">
          Upload Photo — {item.item_code}
          {item.item_name && (
            <Typography variant="body2" color="text.secondary" component="span" sx={{ ml: 1 }}>
              {item.item_name}
            </Typography>
          )}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <ImageUpload
          fixedMetadata={{ itemCode: item.item_code, brand: item.brand }}
          hideFixedFields={true}
          onUploadSuccess={handleUpload}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
